import { render, staticRenderFns } from "./GameFrame.vue?vue&type=template&id=bc53bacc&scoped=true"
import script from "./GameFrame.vue?vue&type=script&lang=js"
export * from "./GameFrame.vue?vue&type=script&lang=js"
import style0 from "./GameFrame.vue?vue&type=style&index=0&id=bc53bacc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc53bacc",
  null
  
)

export default component.exports